// Generated for @nava/participant-copy: Clair's default texts in Finnish. Edit the texts here; the
// participant app's locale files are not read at runtime.
/** Clair's default texts in Finnish. The texts that changed for Clair are translated without native review yet. */
export const PARTICIPANT_COPY_FI = {
    'landing.changeLanguage': 'Vaihda kieltä',
    'common.language': 'Kieli',
    // New for Clair, translated without native review yet.
    'common.talkInLanguages': 'Voit puhua Clairin kanssa yli 80 kielellä.',
    'common.seeLanguages': 'Näytä kielet',
    'footer.poweredBy': 'Palvelun tarjoaa',
    'landing.heading': 'Sinut on kutsuttu lyhyeen keskusteluun.',
    'landing.intro': 'Yritys {company} haluaisi kuulla, miten sinulla menee. Keskustelet Clairin, tekoälyavustajan, kanssa silloin, kun sinulle sopii.',
    'landing.continue': 'Jatka',
    'preflight.title': 'Tarvitsemme vain muutaman asian',
    'preflight.checkInSubtitle': 'Käy alla oleva lista läpi aloittaaksesi keskustelun.',
    'preflight.actions.expandItem': 'Laajenna {{item}}',
    'preflight.microphone.title': 'Mikrofonin käyttöoikeus',
    'preflight.microphone.checkInPrivacy': 'Ääntäsi käytetään keskusteluun Clairin, tekoälyavustajan, kanssa. Keskustelu nauhoitetaan ja litteroidaan, ja sen saa käyttöönsä {company}. Kaikki tiedot salataan ja tallennetaan turvallisesti.',
    'preflight.microphone.readMore': 'Lue lisää',
    'preflight.microphone.grantAccess': 'Anna käyttöoikeus',
    'preflight.microphone.indicatorAction': 'Anna mikrofonin käyttöoikeus',
    'preflight.microphone.accessGranted': 'Käyttöoikeus myönnetty',
    'preflight.microphone.errorHelper': 'Tarkista selaimen asetukset ja yritä uudelleen.',
    'preflight.microphone.browserNotSupported': 'Selaimesi ei tue äänitallennusta. Käytä Chromea, Firefoxia tai Safaria.',
    'preflight.terms.title': 'Tietosuoja ja suostumus',
    'preflight.terms.checkInPrivacy': 'Tätä keskustelua käy Clair, tekoälyavustaja, ja sen järjestää {company}. Vastauksesi saa käyttöönsä {company}, eikä niitä käytetä koskaan mainontaan. Voit lopettaa milloin tahansa.',
    'preflight.terms.readMore': 'Lue lisää',
    'preflight.terms.accept': 'Kyllä, hyväksyn',
    'preflight.terms.indicatorAction': 'Hyväksy tietosuoja ja suostumus',
    'preflight.terms.accepted': 'Hyväksytty',
    'preflight.terms.rememberConsent': 'Muista suostumukseni 30 päivän ajan',
    'preflight.terms.rememberConsentCallTooltip': 'Suostumus tallennetaan vain tätä puhelua varten tähän selaimeen 30 päiväksi.',
    'quickStart.agree': 'Hyväksy',
    'quickStart.back': 'Takaisin',
    'quickStart.cancel': 'Peruuta',
    'preflight.startCheckIn': 'Aloita keskustelu',
    'preflight.preparingCheckIn': 'Keskustelua valmistellaan...',
    'preflight.preparingCheckInDelayedTitle': 'Keskustelua valmistellaan.',
    'preflight.preparingCheckInDelayedSubtitle': 'Valmistelu on vielä kesken, odota hetki.',
    'preflight.preparingCheckInLongSubtitleLineOne': 'Tämä kestää odotettua kauemmin.',
    'preflight.preparingCheckInLongSubtitleLineTwo': 'Ole kärsivällinen.',
    'preflight.checkInPreparationFailedTitle': 'Keskustelua ei voitu valmistella',
    'preflight.checkInPreparationFailedMessage': 'Joitakin keskustelun tiedostoja ei voitu ladata. Tarkista yhteytesi ja yritä uudelleen.',
    'preflight.retryPreparation': 'Try again',
    'interview.status.connecting': 'Yhdistetään',
    'interview.status.speaking': 'Puhuu',
    'interview.status.listening': 'Kuuntelee',
    'interview.status.thinking': 'Ajattelee',
    'interview.question': 'Kysymys {{current}} / {{total}}',
    'interview.mainQuestion': 'Pääkysymys {{current}} / {{total}}',
    'interview.recording': 'Vastaustasi nauhoitetaan...',
    'interview.endInterview': 'Lopeta keskustelu',
    'interview.muteTooltip': 'Mykistä mikrofoni',
    'interview.unmuteTooltip': 'Poista mykistys',
    'interview.pauseTooltip': 'Pidä tauko',
    'interview.resumeTooltip': 'Jatka keskustelua',
    'interview.subtitleTooltip.show': 'Näytä tekstitys (CC)',
    'interview.subtitleTooltip.hide': 'Piilota tekstitys (CC)',
    'interview.toggleChat': 'Kirjoita sen sijaan',
    'interview.toggleVoice': 'Puhu sen sijaan',
    'interview.chatTooltip.type': 'Kirjoita vastauksesi sen sijaan',
    'interview.chatTooltip.speak': 'Puhu vastauksesi sen sijaan',
    'interview.chatTooltip.unavailable': 'Käytettävissä, kun yhteys on valmis',
    'interview.chatDiscoveryHint': 'Etkö voi puhua? Napauta kirjoittaaksesi',
    'interview.chatPlaceholder': 'Kirjoita viestisi...',
    'interview.sendMessage': 'Lähetä',
    'interview.chat.warmHeader': 'Ota aikaa, odotan kun kirjoitat',
    'interview.chat.newlineHint': 'Shift + Enter uudelle riville',
    'interview.chat.aiVoiceOn': 'Ääni päällä',
    'interview.chat.aiVoiceOff': 'Ääni pois',
    'interview.chat.backToVoice': 'Takaisin ääneen',
    'interview.audio.controls': 'Ääniasetukset',
    'interview.audio.callVolume': 'Puhelun äänenvoimakkuus',
    'interview.audio.muteSpeaker': 'Mykistä kaiutin',
    'interview.audio.unmuteSpeaker': 'Poista kaiuttimen mykistys',
    'interview.audio.microphone': 'Mikrofoni',
    'interview.audio.speaker': 'Kaiutin',
    'interview.audio.device': 'Äänilaite',
    'interview.audio.linkedRouting': 'Puhelimesi ohjaa mikrofonia ja kaiutinta yhdessä.',
    'interview.audio.phoneSpeaker': 'Puhelimen kaiutin',
    'interview.audio.phoneEarpiece': 'Puhelimen kuuloke',
    'interview.audio.bluetoothHeadset': 'Bluetooth-kuulokkeet',
    'interview.audio.wiredHeadset': 'Langalliset kuulokkeet',
    'interview.audio.usbAudio': 'USB-ääni',
    'interview.audio.systemDefault': 'Järjestelmän oletus',
    'interview.audio.changeFailed': 'Äänilaitetta ei voitu vaihtaa.',
    'interview.networkQuality.excellent': 'Verkon laatu on erinomainen.',
    'interview.networkQuality.good': 'Verkon laatu on hyvä.',
    'interview.networkQuality.poor': 'Verkon laatu on heikko.',
    'interview.networkQuality.bad': 'Verkon laatu on erittäin heikko.',
    'interview.networkQuality.offline': 'Yhteys on offline-tilassa.',
    'interview.pauseModal.title': 'Keskustelu on tauolla',
    'interview.pauseModal.timeRemaining': '{{time}} jäljellä',
    'interview.pauseModal.timeoutWarning': 'Jos pysyt tauolla, keskustelu päättyy pian itsestään.',
    'interview.pauseModal.resume': 'Jatka keskustelua',
    'interview.pauseModal.end': 'Lopeta keskustelu',
    'interview.endConfirm.title': 'Lopetetaanko keskustelu?',
    'interview.endConfirm.body': 'Et voi palata lopettamisen jälkeen. Tähänastiset vastauksesi tallennetaan.',
    'interview.endConfirm.cancel': 'Jatka keskustelua',
    'interview.endConfirm.end': 'Lopeta keskustelu',
    'complete.checkInTitle': 'Kiitos ajastasi',
    'complete.checkInMessage': 'Vastauksesi menevät yrityksen {company} tiimille.',
    'studyClosed.checkInTitle': 'Tämä keskustelu on suljettu',
    'studyClosed.checkInMessage': 'Kiitos kiinnostuksestasi, se ei enää ota vastaan vastauksia.',
    'studyNotOpen.checkInTitle': 'Tämä keskustelu ei ole vielä auki',
    'studyNotOpen.checkInMessage': 'Kokeile linkkiä myöhemmin uudelleen.',
    'studyNotReady.checkInTitle': 'Tämä keskustelu on melkein valmis',
    'studyNotReady.checkInMessage': 'Kokeile linkkiä uudelleen muutaman minuutin kuluttua.',
    'participantLinkCompleted.checkInTitle': 'Olet jo käynyt tämän keskustelun',
    'participantLinkCompleted.checkInMessage': 'Kiitos ajastasi, sinun ei tarvitse tehdä muuta.',
    'loading.interview': 'Keskustelua ladataan...',
    'browserHelp.title': 'Avaa selaimessasi',
    'browserHelp.description': 'Sovelluksen sisäinen selain saattaa rajoittaa mikrofonin käyttöä. Saat parhaan käyttökokemuksen avaamalla linkin selaimessa: {{browserOptions}}.',
    'browserHelp.namedDescription': 'Sovelluksen {{app}} sisäinen selain saattaa rajoittaa mikrofonin käyttöä. Saat parhaan käyttökokemuksen avaamalla linkin selaimessa: {{browserOptions}}.',
    'browserHelp.appleBrowsers': 'Safari tai Chrome',
    'browserHelp.windowsBrowsers': 'Microsoft Edge tai Chrome',
    'browserHelp.otherBrowsers': 'Chrome tai muu selain',
    'browserHelp.openSafari': 'Avaa Safarissa',
    'browserHelp.copyLink': 'Kopioi linkki',
    'browserHelp.copied': 'Linkki kopioitu. Liitä se selaimeesi.',
    'browserHelp.manualCopy': 'Automaattinen kopiointi ei onnistunut. Valitse ja kopioi alla oleva linkki.',
    'browserHelp.copyInstructions': 'Kopioi alla oleva linkki ja liitä se toiseen selaimeen. Voit myös etsiä sovelluksen valikosta vaihtoehdon, jolla sivu avataan oletusselaimessasi.',
    'browserHelp.linkLabel': 'Keskustelun linkki',
    'browserHelp.continueAnyway': 'Jatka silti',
    'preflight.microphone.recovery.denied': 'Mikrofonin käyttö estetty.',
    'preflight.microphone.recovery.timedOut': 'Mikrofonin käyttöoikeuspyyntö kesti liian kauan. Tarkista, näkyykö selaimessa lupapyyntö, ja yritä uudelleen.',
    'preflight.microphone.recovery.notFound': 'Mikrofonia ei löytynyt. Liitä mikrofoni ja yritä uudelleen.',
    'preflight.microphone.recovery.notReadable': 'Mikrofonia ei voitu ottaa käyttöön. Sulje muut sitä käyttävät sovellukset ja yritä uudelleen.',
    'preflight.microphone.recovery.failed': 'Emme saaneet yhteyttä mikrofoniisi. Tarkista mikrofoni ja yritä uudelleen.',
    'preflight.microphone.recovery.retry': 'Yritä uudelleen',
    'preflight.microphone.recovery.close': 'Sulje',
    'preflight.microphone.recovery.helpTitle': 'Salli mikrofonin käyttö',
    'preflight.microphone.recovery.helpDescription': 'Mikrofonin käyttö on edelleen estetty. Selaimesi saattaa muistaa aiemman valintasi eikä siksi pyydä lupaa uudelleen.',
    'preflight.microphone.recovery.safariMacSettings': 'Valitse Safarin valikkoriviltä Safari > Asetukset > Verkkosivustot > Mikrofoni. Etsi tämä sivusto luettelosta.',
    'preflight.microphone.recovery.chromiumSettings': 'Napsauta osoitepalkin vasemmalla puolella olevaa sivuston asetusten kuvaketta ja valitse Sivustoasetukset > Mikrofoni.',
    'preflight.microphone.recovery.siteSettings': 'Avaa tämän sivuston käyttöoikeudet osoiterivin vieressä olevasta kuvakkeesta tai valikosta tai selaimen sivustoasetuksista.',
    'preflight.microphone.recovery.allowMicrophone': 'Salli mikrofonin käyttö tälle sivustolle, palaa tänne ja valitse ”Yritä uudelleen”. Jos selain pyytää lataamaan sivun uudelleen, tee niin.',
    'preflight.microphone.recovery.deviceSettings': 'Jos käyttö on jo sallittu, tarkista laitteen asetuksista, että tämä selain saa käyttää mikrofonia.',
    'microphoneQuality.title': 'Mikrofonin laatu',
    'microphoneQuality.instructions': 'Puhu muutama sekunti, jotta voimme tarkistaa, kuinka hyvin kuulemme sinut.',
    'microphoneQuality.recoveryMessage': 'Emme kuule sinua. Jos puhut puhelua, lopeta se ensin. Sulje muut mikrofonia käyttävät sovellukset ja yritä uudelleen.',
    'microphoneQuality.poor': 'Heikko',
    'microphoneQuality.almostThere': 'Melkein valmis',
    'microphoneQuality.perfect': 'Täydellinen!',
    'microphoneQuality.waiting': 'Odotetaan ääntä...',
    'microphoneQuality.from': 'Lähde',
    'microphoneQuality.defaultDevice': 'Oletusmikrofoni',
    'microphoneQuality.helpText': 'Puhu kovemmin tai siirry lähemmäksi mikrofonia',
    'microphoneQuality.done': 'Valmis',
    'startupRecovery.title': 'Keskustelu ei käynnistynyt',
    'startupRecovery.failed': 'Emme saaneet yhteyttä keskustelupalveluun. Yritä uudelleen.',
    'startupRecovery.timedOut': 'Yhteyden muodostaminen kesti liian kauan. Yritä uudelleen.',
    'startupRecovery.cancelled': 'Yhteyden muodostaminen peruttiin. Voit yrittää uudelleen, kun olet valmis.',
    'startupRecovery.microphone': 'Mikrofonia ei voitu käyttää. Tarkista käyttöoikeudet ja yritä uudelleen.',
    'startupRecovery.delayed': 'Yhteyttä muodostetaan edelleen. Tämä kestää tavallista kauemmin…',
    'startupRecovery.retry': 'Yritä uudelleen',
    'startupRecovery.support': 'Tuen viitetunnus',
    'startupRecovery.copy': 'Kopioi viitetunnus',
    'startupRecovery.copied': 'Kopioitu',
    'startupRecovery.checking': 'Tarkistetaan yhteyttä…',
    'startupRecovery.unavailable': 'Ei voitu vahvistaa',
    'startupRecovery.advice': 'Tarkistus testaa vain palvelujen tavoitettavuutta. Voit silti yrittää aloittaa. Jos se ei onnistu, kokeile toista selainta tai verkkoa.',
    'startupRecovery.checkAgain': 'Tarkista yhteys uudelleen...',
    'connectionDetails.quality': 'Verkon laatu',
    'connectionDetails.excellent': 'Erinomainen',
    'connectionDetails.good': 'Hyvä',
    'connectionDetails.poor': 'Heikko',
    'connectionDetails.bad': 'Huono',
    'connectionDetails.offline': 'Ei verkkoyhteyttä',
    'connectionDetails.notChecked': 'Ei tarkistettu',
    'connectionDetails.lastChecked': 'Viimeksi tarkistettu',
    'connectionDetails.warning': 'Yhteyttä ei voitu vahvistaa: {{services}}.',
    'connectionDetails.navaApi': 'Clairin API',
    'connectionDetails.interviewApi': 'Clairin keskustelupalvelu',
    'connectionDetails.ok': 'OK',
    'connectionDetails.refresh': 'Päivitä yhteystesti',
    'connectionDetails.success': 'Yhteystarkistus onnistui.',
    'connection.error': 'Yhteysvirhe',
    'connection.errorDefault': 'Yhteyttä keskustelupalveluun ei saatu',
    'connection.retry': 'Yritä uudelleen',
    'versionRefresh.message': 'Uusi versio on saatavilla. Päivitä selaimesi, kun olet valmis.',
    'versionRefresh.action': 'Päivitä',
    'cookies.banner.title': 'Arvostamme yksityisyyttäsi',
    'cookies.banner.message': 'Käytämme evästeitä optimoidaksemme kokemustasi, ymmärtääksemme tuotteen käyttöä ja tukeaksemme relevanttia markkinointia. Valitse <bold>“Hyväksy kaikki”</bold> hyväksyäksesi kaikki evästeet tai <bold>“Hallitse asetuksia”</bold> muokataksesi asetuksiasi.',
    'cookies.banner.privacyPolicy': 'Tietosuojakäytäntö',
    'cookies.banner.acceptAll': 'Hyväksy kaikki',
    'cookies.banner.managePreferences': 'Hallitse asetuksia',
    'cookies.modal.title': 'Evästeasetukset',
    'cookies.modal.description': 'Kun vierailet Clairissa, voimme tallentaa tai hakea sinua koskevia tietoja evästeiden ja vastaavien tekniikoiden avulla. Välttämättömät evästeet pitävät sivuston toiminnassa. Voit muuttaa valinnaisia asetuksia milloin tahansa.',
    'cookies.modal.readMore': 'Lue lisää',
    'cookies.modal.save': 'Tallenna',
    'cookies.modal.close': 'Sulje evästeasetukset',
    'cookies.modal.essential.title': 'Välttämättömät',
    'cookies.modal.essential.description': 'Tarvitaan verkkosivuston perustoimintoihin. Välttämättömiä evästeitä ei voi poistaa käytöstä.',
    'cookies.modal.analytics.title': 'Analytiikka',
    'cookies.modal.analytics.description': 'Auttaa Clairia ymmärtämään, miten sivusto toimii, miten kävijät käyttävät sitä ja onko siinä mahdollisesti teknisiä ongelmia.',
    'invitation.subject': 'Lyhyt keskustelu yrityksen {company} kanssa',
    'invitation.greeting': 'Hei {name},',
    'invitation.body': 'Haluaisimme kuulla, miten sinulla menee.',
    'invitation.aiNotice': 'Keskustelet Clairin, tekoälyavustajamme, kanssa. Useimpien mielestä on helpompi olla rehellinen tekoälylle kuin ihmiselle, ja voit tehdä sen silloin, kun sinulle sopii, töissä tai kotona.',
    'invitation.button': 'Aloita keskustelu',
    'invitation.fallbackLink': 'Tai liitä tämä linkki selaimeesi:',
    'invitation.footer': 'Saat tämän viestin, koska olet yrityksen {company} asiakas. Keskustelua käy yrityksen puolesta Clair, tekoälyavustaja.',
    'invitation.optOut': 'Älä lähetä näitä minulle enää',
    'sms.invite': 'Yritys {company} kutsuu sinut lyhyeen keskusteluun:',
    'sms.stop': 'Lopeta tekstiviestit:',
};
//# sourceMappingURL=fi.js.map